import * as d3 from 'd3-selection'

/*
 * Draws a containing rect around the components so we can use
 * a `title` to show hoverText. See SB3 #23065
 */
export default function (dimensions, field) {
  var draw = function (selection) {
    selection.each(function () {
      var rect = d3.select(this)
                   .selectAll('rect.hover-container').data(d => d.hoverText ? [d.hoverText] : [])
        , enter = rect.enter()
                      .append('rect')
                        .attr('class', 'hover-container')
                        .attr('width', '100%')
                        .attr('height', '100%')

      enter.append('title')

      rect.merge(enter).selectAll('title')
                       .data(d => [d])
                       .text(String)

      rect.exit().remove()
    })
  }

  return draw
}
